import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=147a2bb3&scoped=true&"
import script from "./ContentPage.vue?vue&type=script&lang=js&"
export * from "./ContentPage.vue?vue&type=script&lang=js&"
import style1 from "./ContentPage.vue?vue&type=style&index=1&id=147a2bb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a2bb3",
  null
  
)

export default component.exports